import { Linking, Platform } from 'react-native';
import type { LocationCoordinates } from '@/services/location';

/** Universal HTTPS link suitable for clipboard / web. */
export function buildGoogleMapsSearchUrl(coord: LocationCoordinates): string {
  const { latitude, longitude } = coord;
  return `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
}

/** Platform-native “directions to this point” URL (Apple Maps / Google navigation / HTTPS fallback). */
export function buildDirectionsUrl(coord: LocationCoordinates): string {
  const { latitude, longitude } = coord;
  return (
    Platform.select({
      ios: `maps://maps.apple.com/?daddr=${latitude},${longitude}`,
      android: `google.navigation:q=${latitude},${longitude}`,
      default: buildGoogleMapsSearchUrl(coord),
    }) ?? buildGoogleMapsSearchUrl(coord)
  );
}

export async function openDirectionsToCoordinate(coord: LocationCoordinates): Promise<void> {
  const primary = buildDirectionsUrl(coord);
  try {
    await Linking.openURL(primary);
  } catch (err) {
    if (Platform.OS === 'android' && primary.startsWith('google.navigation:')) {
      try {
        await Linking.openURL(buildGoogleMapsSearchUrl(coord));
      } catch (fallbackErr) {
        console.error('[openExternalMaps] Fallback Google Maps open failed:', fallbackErr);
      }
    } else {
      console.error('[openExternalMaps] Open maps failed:', err);
    }
  }
}
